import { useContext } from 'react'
import { RouteContext } from '../components'

const useRouteContext = (component, force = true) => {
  const context = useContext(RouteContext)
  if (force && !context) {
    const err = new Error(`<${component} /> is missing RouteContext`)
    if (Error.captureStackTrace) Error.captureStackTrace(err, useRouteContext)
    throw err
  }
  return context
}

export default useRouteContext
